import { render } from "./message-handler.vue?vue&type=template&id=146d9ea7"
import script from "./message-handler.vue?vue&type=script&lang=js"
export * from "./message-handler.vue?vue&type=script&lang=js"

import "./message-handler.vue?vue&type=style&index=0&id=146d9ea7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__